import React, { useEffect, useState } from "react";
import { get, omitBy } from "lodash/fp";
import {
  Container,
  Panel,
  Pagination,
  Table,
  Footer,
  Content,
  Button,
  Form,
  Toggle,
  Col,
  SelectPicker,
  Row,
  Grid,
  Divider,
} from "rsuite";
import EditIcon from "@rsuite/icons/Edit";
import TrashIcon from "@rsuite/icons/Trash";
import CustomCell from "../../components/Elements/CustomCell";
import CustomHeaderCell from "../../components/Elements/CustomHeaderCell";
import { updateIn } from "json-immut";
import { useTranslation } from "react-i18next";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import { HelperServices } from "../../../core/services/HelperServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { useSelector } from "react-redux";
import {
  statusArr,
  appConstObj,
  buildingTypeObjArr,
} from "../../../core/config/AppConstants";
import { isEmptyVal, isNotEmpty, isNotNull } from "../../../utils/helpers";
import {
  messageTypeArr,
  httpStatusArr,
} from "../../../core/config/AppConstants";
import "./Buildings.css";

function Buildings() {
  const { Column } = Table;
  const [loading, setLoading] = useState(false);
  const countryList = useSelector((state: any) => state.country.data);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [areaList, setAreaList] = useState([]);
  const [showFilter, setDisplayFilter] = useState(false);
  const [showAdd, setDisplayAdd] = useState(false);
  const [buildingData, setBuildingData] = useState<any[]>([]);
  const [buildingTotal, setBuildingTotal] = useState(0);

  const [rows, setRows] = useState(10);
  const [page, setPage] = useState(1);
  const [sort_by, setSortBy] = useState<any>();
  const [sort_order, setSortOrder] = useState<any>();
  const [selectedBuildingId, setSelectedBuildingId] = useState();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const defaultSettings = UtilityServices.getLoggedInUser("settings");
  const buildingList = buildingTypeObjArr;
  const initSearchFormData = {
    id: "",
    type: "",
    name: "",
    area: !isEmptyVal(defaultSettings["default_area"])
      ? defaultSettings["default_area"]
      : "",
    city: !isEmptyVal(defaultSettings["default_city"])
      ? defaultSettings["default_city"]
      : "",
    state: !isEmptyVal(defaultSettings["default_state"])
      ? defaultSettings["default_state"]
      : "",
    country: !isEmptyVal(defaultSettings["default_country"])
      ? defaultSettings["default_country"]
      : "",
    status: statusArr.active,
    is_allowed: "0,1",
  };

  const [formData, setFormData] = useState<any>(initSearchFormData);

  const [errors, setErrors] = useState<any>({});
  const { t } = useTranslation();

  async function viewBuilding(param: any) {
    try {
      setLoading(true);
      const response: any = await HelperServices.viewBuilding(param);
      let values = response.data.data;

      setFormData({
        id: values.id,
        area: values.area_id,
        city: values.city_id,
        country: values.city.country_id,
        state: values.city.state_id,
        name: values.building_name,
        type: values.building_type.toLowerCase(),
        status: values.status,
      });
      setLoading(false);
    } catch (error: any) {
      console.log("error ", error);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setLoading(false);
    }
  }

  function getSearchParams(data?: any) {
    let paramsData = {
      ...formData,
      ...{ sort_by, sort_order },
      ...{ rows },
      ...data,
    };
    let params: any = omitBy(isEmptyVal, paramsData);
    if (data?.page) {
      params.page = data?.page;
    }

    return params;
  }

  async function getBuildings(param: any) {
    try {
      if (isEmptyVal(param?.city)) return;
      setLoading(true);
      const response: any = await HelperServices.getBuildings(param);
      setBuildingData(get("data.data", response));
      setBuildingTotal(get("data.total", response));
      setLoading(false);
    } catch (error: any) {
      console.log("error ", error);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setLoading(false);
    }
  }

  const filterBuildings = () => {
    let dumpError: any = [];
    let i;
    let data = { ...formData };
    let fieldsRequired: any = {
      country: "COUNTRY",
      state: "STATE",
      city: "CITY",
    };

    for (i in data) {
      if (isEmptyVal(data[i]) && i in fieldsRequired) {
        dumpError[i] =
          t("PLEASE_SELECT") + " " + t(fieldsRequired[i]).toLowerCase();
        setErrors(dumpError);
      } else {
        delete dumpError[i];
        setErrors(dumpError);
      }
    }

    if (Object.keys(dumpError).length == 0) {
      delete data.id;
      getBuildings(
        getSearchParams({
          ...data,
        })
      );
    }
  };

  const handleFormChanges = (data: any) => {
    if (data.path == "status") {
      if (data.value) {
        data.value = 1;
      } else {
        data.value = 0;
      }
    }

    let form = updateIn(formData, [data.path], data.value);
    setFormData(form);
  };
  const saveBuilding = async () => {
    try {
      let dumpError: any = [];
      let i;
      let response: any = {};
      let fieldsConst: any = {
        name: "BUILDING_NAME",
        type: "BUILDING_TYPE",
        area: "AREA",
      };

      for (i in formData) {
        if (formData[i] == "" && i != "id" && i != "status") {
          if (i == "name") {
            dumpError[i] = t("REQUIRED", {
              field: t(fieldsConst[i]).toLowerCase(),
            });
          } else {
            dumpError[i] =
              t("PLEASE_SELECT") + " " + t(fieldsConst[i]).toLowerCase();
          }
          setErrors(dumpError);
        } else {
          delete dumpError[i];
          setErrors(dumpError);
        }
      }

      if (Object.keys(dumpError).length == 0) {
        setLoading(true);
        let params = {
          building_name: formData.name,
          building_type: formData.type,
          area_id: formData.area,
          status: formData.status,
          id: formData.id,
        };

        if (params.id == "") {
          response = await HelperServices.addBuilding(params);
        } else {
          response = await HelperServices.updateBuilding(params);
        }

        UtilityServices.showToaster({
          message: response?.data?.message,
        });
        setFormData({
          ...initSearchFormData,
          ...{
            country: formData.country,
            state: formData.state,
            city: formData.city,
            area: formData.area,
          },
        });
        setPage(1);

        getBuildings(
          getSearchParams({
            ...initSearchFormData,
            ...{
              country: formData.country,
              state: formData.state,
              city: formData.city,
              area: formData.area,
            },
          })
        );
      }

      setLoading(false);
    } catch (error: any) {
      if (formData.id == "") {
        UtilityServices.showToaster({
          message: error?.message,
          type: messageTypeArr.error,
        });
      } else {
        UtilityServices.showToaster({
          message: error?.message,
          type: messageTypeArr.error,
        });
      }
      setLoading(false);
    }
  };

  const editBuilding = async (values: any) => {
    setDisplayAdd(true);
    setDisplayFilter(false);
    viewBuilding(values.id);
  };

  const deleteBuilding = async (id: any) => {
    try {
      setLoading(true);
      const response: any = await HelperServices.deleteBuilding({ id: id });
      UtilityServices.showToaster({
        message: response?.data?.message,
      });

      getBuildings(
        getSearchParams({
          ...initSearchFormData,
          ...{
            city: formData.city,
            page: 1,
            rows: appConstObj.record_per_page,
          },
        })
      );
      setLoading(false);
    } catch (error: any) {
      console.log("error ", error);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setLoading(false);
    }
  };

  function onPageChange(page: number) {
    setPage(page);
    delete formData.id;
    getBuildings(
      getSearchParams({
        page: page,
        sort_by: sort_by,
        sort_order: sort_order,
        rows: rows,
      })
    );
  }

  function onSortChange(dataKey: any, sortType: any) {
    setPage(1);
    setSortBy(dataKey);
    setSortOrder(sortType);

    getBuildings(
      getSearchParams({
        page: 1,
        sort_by: dataKey,
        sort_order: sortType,
        rows: rows,
      })
    );
  }

  const handleChangeRows = (rows: any) => {
    setRows(rows);
    setPage(1);
    getBuildings(
      getSearchParams({
        page: 1,
        sort_by: sort_by,
        sort_order: sort_order,
        rows: rows,
      })
    );
  };

  const toggleFilterOptions = () => {
    setDisplayFilter((value) => !value);
  };

  const toggleadAddOptions = () => {
    setDisplayAdd((value) => !value);
  };

  function clearSearch() {
    setFormData(initSearchFormData);
    setSortBy(null);
    setSortOrder(null);
    setPage(1);
    setRows(appConstObj.record_per_page);
    getBuildings(
      getSearchParams({
        ...initSearchFormData,
        ...{
          page: 1,
          rows: appConstObj.record_per_page,
        },
      })
    );

    loadUserDefaultSettings();
  }

  const cancelAction = async () => {
    setErrors({});
    setDisplayFilter(false);
    setDisplayAdd(false);
  };

  async function init() {
    try {
      loadUserDefaultSettings();
    } catch (error: any) {
      console.log("error ", error);
    }
  }
  useEffect(() => {
    init();
    getBuildings(
      getSearchParams({
        ...initSearchFormData,
        ...{
          page: 1,
          rows: appConstObj.record_per_page,
        },
      })
    );
  }, []);

  function loadUserDefaultSettings() {
    setLoading(true);

    let obj = { ...initSearchFormData };
    if (!isEmptyVal(defaultSettings["default_country"])) {
      obj["country"] = parseInt(defaultSettings["default_country"]);
    }
    if (!isEmptyVal(defaultSettings["default_state"])) {
      obj["state"] = parseInt(defaultSettings["default_state"]);
    }
    if (!isEmptyVal(defaultSettings["default_city"])) {
      obj["city"] = parseInt(defaultSettings["default_city"]);
    }
    if (!isEmptyVal(defaultSettings["default_area"])) {
      obj["area"] = parseInt(defaultSettings["default_area"]);
    }
    setFormData({ ...obj });
    preSelectFields(obj);
    setLoading(false);
  }

  async function preSelectFields(obj: any) {
    if (obj.country) {
      handleCountryChange(obj.country);
    }
    if (obj.state) {
      handleStateChange(obj.state);
    }
    if (obj.city) {
      handleCityChange(obj.city);
    }
  }

  async function handleCountryChange(countryId: number) {
    try {
      const stateRes = await HelperServices.getAllValidStates({
        country: countryId,
      });
      setStateList(get("data.data", stateRes));
      resetSelectionFor("state");
      handleFormChanges({ path: "country", value: countryId });
    } catch (error) {
      console.log(error);
    }
  }

  async function handleStateChange(stateId: number) {
    try {
      const res = await HelperServices.getAllValidCities({ state: stateId });
      setCityList(res.data.data);
      resetSelectionFor("city");
      handleFormChanges({ path: "state", value: stateId });
    } catch (error) {
      console.log(error);
    }
  }

  async function handleCityChange(cityId: number) {
    try {
      const res = await HelperServices.getAllValidAreas({ city: cityId });
      setAreaList(res.data.data);
      resetSelectionFor("area");
      handleFormChanges({ path: "city", value: cityId });
    } catch (error) {
      console.log(error);
    }
  }

  function resetSelectionFor(resetFor: string) {
    let resetData: Object = {};
    switch (resetFor) {
      case "country":
        resetData = {
          country: "",
          state: "",
          city: "",
          area: "",
        };
        setStateList([]);
        setCityList([]);
        setAreaList([]);
        break;
      case "state":
        resetData = {
          state: "",
          city: "",
          area: "",
        };
        setCityList([]);
        setAreaList([]);
        break;
      case "city":
        resetData = {
          city: "",
          area: "",
        };
        setAreaList([]);
        break;
      case "area":
        resetData = {
          area: "",
        };
        break;
    }
    let newFormData = {
      ...formData,
      ...resetData,
    };
    setFormData(newFormData);
  }

  return (
    <div className="users cntry">
      <Container className="container">
        <Panel>
          <Grid fluid>
            <Row className="show-grid mb-2">
              <Col md={12}>
                <h4>{t("BUILDINGS")}</h4>
              </Col>
              <Col md={12} mdPush={9}>
                <Button
                  appearance="default"
                  size="sm"
                  className="mr-2"
                  onClick={toggleFilterOptions}
                  disabled={showAdd}
                >
                  {t("FILTER")}
                </Button>
                &nbsp;
                <Button
                  appearance="primary"
                  size="sm"
                  onClick={toggleadAddOptions}
                  disabled={showFilter}
                >
                  {t("ADD")}
                </Button>
              </Col>
            </Row>
          </Grid>
          {showFilter || showAdd ? (
            <Form formValue={formData}>
              <div className="col-md-12 building-form-div content pl-0 pb-0 mb-2">
                <div className="row mb-0">
                  <div className="col-md-12 d-flex space-between">
                    <Form.Group controlId="name" className="mb-0">
                      <Form.ControlLabel>{t("NAME")}</Form.ControlLabel>
                      <Form.Control
                        name="name"
                        className={
                          errors["name"]
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        onChange={(v: any) =>
                          handleFormChanges({ path: "name", value: v })
                        }
                      />
                      <span className="text-danger">{errors["name"]}</span>
                    </Form.Group>
                    <Form.Group controlId="country" className="mb-0">
                      <Form.ControlLabel>{t("Country")}</Form.ControlLabel>
                      <SelectPicker
                        data={countryList}
                        valueKey="id"
                        labelKey="country_name"
                        onSelect={(value, item) => {
                          handleCountryChange(value);
                        }}
                        onClean={(e: any) => {
                          resetSelectionFor("country");
                        }}
                        name="country"
                        className={
                          errors["country"]
                            ? "form-select is-invalid"
                            : "form-select"
                        }
                        value={formData?.country}
                      />
                      <span className="text-danger">{errors["country"]}</span>
                    </Form.Group>
                    <Form.Group controlId="city" className="mb-0">
                      <Form.ControlLabel>{t("CITY")}</Form.ControlLabel>
                      <SelectPicker
                        data={cityList}
                        valueKey="id"
                        labelKey="city_name"
                        onSelect={(value, item) => {
                          handleCityChange(value);
                        }}
                        onClean={(e: any) => {
                          resetSelectionFor("city");
                        }}
                        name="city"
                        className={
                          errors["city"]
                            ? "form-select is-invalid"
                            : "form-select"
                        }
                        value={formData?.city}
                      />
                      <span className="text-danger">{errors["city"]}</span>
                    </Form.Group>
                    <Form.Group controlId="type" className="mb-0">
                      <Form.ControlLabel>{t("TYPE")}</Form.ControlLabel>
                      <SelectPicker
                        data={buildingList}
                        valueKey="value"
                        labelKey="label"
                        onSelect={(value, item) => {
                          handleFormChanges({ path: "type", value });
                        }}
                        name="type"
                        className={
                          errors["type"]
                            ? "form-select  is-invalid"
                            : "form-select"
                        }
                        onClean={(e: any) => {
                          handleFormChanges({ path: "type", value: "" });
                        }}
                        value={formData?.type}
                      />
                      <span className="text-danger">{errors["type"]}</span>
                    </Form.Group>
                    <Form.Group controlId="state" className="mb-0">
                      <Form.ControlLabel>{t("STATE")}</Form.ControlLabel>
                      <SelectPicker
                        data={stateList}
                        valueKey="id"
                        labelKey="state_name"
                        onSelect={(value, item) => {
                          handleStateChange(value);
                        }}
                        onClean={(e: any) => {
                          resetSelectionFor("state");
                        }}
                        name="state"
                        className={
                          errors["state"]
                            ? "form-select  is-invalid"
                            : "form-select"
                        }
                        value={formData?.state}
                      />
                      <span className="text-danger">{errors["state"]}</span>
                    </Form.Group>
                    <Form.Group controlId="area" className="mb-0">
                      <Form.ControlLabel>{t("AREA")}</Form.ControlLabel>
                      <SelectPicker
                        data={areaList}
                        valueKey="id"
                        labelKey="area_name"
                        onSelect={(value, item) => {
                          handleFormChanges({ path: "area", value });
                        }}
                        onClean={(e: any) => {
                          resetSelectionFor("area");
                        }}
                        name="area"
                        className={
                          errors["area"]
                            ? "form-select  is-invalid"
                            : "form-select"
                        }
                        value={formData?.area}
                      />
                      <span className="text-danger">{errors["area"]}</span>
                    </Form.Group>
                  </div>
                </div>
                <Row className="mt-4">
                  <Col md={5}>
                    <Form.Group>
                      {t("STATUS")}:{" "}
                      <Form.Control
                        name="status"
                        accepter={Toggle}
                        checked={formData.status}
                        onChange={(v: any) =>
                          handleFormChanges({ path: "status", value: v })
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <div className="mt-0 mb-0 form-btn create-action d-flex flex-end">
                  {showFilter ? (
                    <React.Fragment>
                      <Button
                        className="rs-btn-deflt "
                        appearance="primary"
                        onClick={filterBuildings}
                      >
                        {t("SEARCH")}
                      </Button>
                      <Button
                        className="rs-btn-blue"
                        appearance="primary"
                        onClick={(e) => clearSearch()}
                      >
                        {t("CLEAR")}
                      </Button>
                    </React.Fragment>
                  ) : (
                    ""
                  )}
                  {showAdd ? (
                    <Button
                      className="rs-btn-green"
                      appearance="primary"
                      onClick={saveBuilding}
                    >
                      {t("SAVE")}
                    </Button>
                  ) : (
                    ""
                  )}
                  <Button
                    color="orange"
                    appearance="primary"
                    onClick={cancelAction}
                  >
                    {t("CANCEL")}
                  </Button>
                </div>
              </div>
            </Form>
          ) : (
            ""
          )}
          <Content>
            <Table
              loading={loading}
              height={400}
              fillHeight={true}
              data={buildingData}
              hover={true}
              onSortColumn={onSortChange}
              sortColumn={sort_by}
              sortType={sort_order}
              bordered
              cellBordered
            >
              <Column fixed flexGrow={1} align="left" sortable>
                <CustomHeaderCell>{t("NAME")}</CustomHeaderCell>
                <CustomCell dataKey="building_name" />
              </Column>

              <Column flexGrow={1} align="center" sortable>
                <CustomHeaderCell>
                  {t("BUILDING")} {t("TYPE")}
                </CustomHeaderCell>
                <CustomCell dataKey="building_type" />
              </Column>
              <Column flexGrow={1} align="center" sortable>
                <CustomHeaderCell>{t("AREA")}</CustomHeaderCell>
                <CustomCell dataKey="area_name" />
              </Column>
              <Column flexGrow={1} align="center" sortable>
                <CustomHeaderCell>{t("CITY")}</CustomHeaderCell>
                <CustomCell dataKey="city_name" />
              </Column>
              <Column flexGrow={1} align="center" sortable>
                <CustomHeaderCell>{t("PINCODE")}</CustomHeaderCell>
                <CustomCell dataKey="pincode" />
              </Column>

              <Column flexGrow={1} align="center">
                <CustomHeaderCell>{t("ACTION")}</CustomHeaderCell>
                <CustomCell>
                  {(rowData: any) => {
                    return (
                      <React.Fragment>
                        <a
                          href="javascript:void(0)"
                          onClick={() => editBuilding(rowData)}
                          title={t("EDIT")}
                        >
                          <EditIcon />
                        </a>
                        &nbsp;
                        <a
                          href="javascript:void(0)"
                          onClick={() => {
                            setOpenDeleteModal(true);
                            setSelectedBuildingId(rowData.id);
                          }}
                          title={t("DELETE")}
                        >
                          <TrashIcon />
                        </a>
                      </React.Fragment>
                    );
                  }}
                </CustomCell>
              </Column>
            </Table>
          </Content>
          <Footer className="footer">
            <Pagination
              total={buildingTotal}
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="xs"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              limitOptions={appConstObj.limit_options}
              limit={rows}
              activePage={page}
              onChangePage={onPageChange}
              onChangeLimit={handleChangeRows}
            />
          </Footer>
        </Panel>
      </Container>

      <AlertModal
        open={openDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            deleteBuilding(selectedBuildingId);
            setOpenDeleteModal(false);
          } else {
            setOpenDeleteModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION", {
          action: t("DELETE").toLowerCase(),
          entity: t("BUILDING").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("BUILDING").toLowerCase(),
        })}
      />
    </div>
  );
}

export default Buildings;
